import styled from "@emotion/styled";

const CenterEl = styled.div`
  label: BehavioralHealthDialogAssessmentCenterEl;
  border-radius: 0.6em;
  height: 100%;
  text-align: center;
  margin: 0 auto;
  display: flex;
  justify-content: center;

  @media (orientation: portrait) {
    text-align: center;
  }
`;

const BehavioralAssessmentWrapper = styled.div`
  label: BehavioralAssessmentWrapper;
  display: flex;
  height: 100%;
  flex-flow: column nowrap;
  flex: 0 0 29.625rem /* 474/16 */;
  font-family: var(--font-family);

  @media screen and (max-width: 730px) {
    flex: 0 0 20.5rem /* 328/16 */;
  }
`;

const BehavioralAssessmentTitle = styled.h4`
  label: BehavioralAssessmentTitle;
  flex: 1 0 auto;
  align-content: end;
  font-feature-settings:
    "liga" off,
    "clig" off;

  font-size: 2.5rem;
  font-style: normal;
  font-weight: 300;
  line-height: 110%; /* 44px */
  letter-spacing: -0.063rem;

  margin-bottom: 1.5rem /* 24/16 */;
`;

const BehavioralAssessmentDescription = styled.div`
  label: BehavioralAssessmentDescription;
  flex: 0 0 auto;
  font-feature-settings:
    "liga" off,
    "clig" off;

  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.02rem;
  margin-bottom: 2.5rem /* 40/16 */;
`;

const BehavioralAssessmentAction = styled.div`
  label: BehavioralAssessmentAction;
  display: flex;
  flex: 1 0 auto;
  align-items: start;
  justify-content: center;
  font-feature-settings:
    "liga" off,
    "clig" off;

  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.02rem;
  margin-bottom: 2.5rem /* 40/16 */;
`;

export const BehavioralHealthDialogAssessmentStyled = {
  CenterEl,
  BehavioralAssessmentWrapper,
  BehavioralAssessmentTitle,
  BehavioralAssessmentDescription,
  BehavioralAssessmentAction
};
